import { ReturnTranslatedText } from '@wajeez-web/core/localization';

interface FieldArrayContentProps {
  label: string | undefined;
  value: string[] | number[] | undefined;
}

export const FieldArrayContent = ({ label, value }: FieldArrayContentProps) => {
  return (
    <div className="w-full">
      <div className="text-[16px] font-medium">
        <ReturnTranslatedText
          text={`inputs.labels.${label}`}
          origintext={label}
        />
      </div>
      <div className="mt-1 p-2 flex justify-start items-center flex-wrap space-s-2 rounded bg-warmGray-200 text-[14px] font-normal">
        {value?.map((v) => {
          return <div className="mt-1 p-1 bg-white rounded-sm">{v}</div>;
        })}
      </div>
    </div>
  );
};
